export default __webpack_public_path__ + "static/media/logo-light.66fbbf77.svg";